// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
Widgets.BoxOver = Widgets.Base.inherit({
    widget_name: "BoxOver",
    url: null,
    internal_definition: null,
    type: null,
    title: null,
    width: null,
    height: null,
    top: null,
    positioning: null,

    DEFAULT_TOP: 75,
    DEFAULT_WIDTH: 500,
    DEFAULT_HEIGHT: 300,

    init: function(options) {
        if ('undefined' !== typeof options.iframe) {
            this.url = options.iframe;
        }
        if ('undefined' !== typeof options.title) {
            this.title = options.title;
        }
        if ('undefined' !== typeof options.width) {
            this.width = parseInt(options.width, 10);
        } else {
            this.width = this.DEFAULT_WIDTH;
        }
        if ('undefined' !== typeof options.height) {
            this.height = parseInt(options.height, 10);
        } else {
            this.height = this.DEFAULT_HEIGHT;
        }
        if ('undefined' !== typeof options.top) {
            this.top = parseInt(options.top, 10);
        } else {
            this.top = this.DEFAULT_TOP;
        }

        if ('undefined' !== typeof options.onclose) {
          this.onclose = options.onclose;
        } else {
          this.onclose = function() {}
        }

        if (options.positioning == 'absolute') {
            this.positioning = 'absolute';
            this.top += $(window).scrollTop();
        } else {
            this.ensure_all_visible();
        }

        this.build();
    },

    /*
     * If necessary, switch the boxover from fixed to absolute positioning so
     * the user can scroll down. Right now, this never switches back to fixed.
     */
    ensure_all_visible: function() {
        var window_top    = $(window).scrollTop(),
            window_height = $(window).height(),
            j_el          = this.j_element,
            top           = !j_el ? this.top    : j_el.offset().top - window_top,
            height        = !j_el ? this.height : j_el.height();

        if (top + height > window_height) {
            this.positioning = 'absolute';
            this.top += window_top;
        } else {
            this.positioning = 'fixed';
        }

        if (this.j_element) {
            this.j_element.css({
                position: this.positioning,
                top: this.top
            });
        }
    },

    content_width: function() {
        return this.width;
    },

    content_height: function() {
        return this.height;
    },

    set_height: function(height, speed, complete) {
        var self = this,
            title_height = self.j_element.find('.container_title_bar').height();

        this.height = height;

        if (!speed) {
            speed = "fast";
        }

        var after_height_change = function() {
            self.j_element.height(height + title_height);

            if (self.positioning == 'fixed') {
                self.ensure_all_visible();
            }

            if (complete && typeof(complete) == "function") {
                complete();
            }
        };

        if (true) {
            self.j_element.find('iframe').animate({
                'height': '' + self.height + 'px'
            },
            speed,
            function() {
                self.j_element.css({
                    'height': '' + self.height + 'px'
                });

                self.j_element.find('table').css({
                    'height': '' + self.height + 'px'
                });

                after_height_change();
            });
        }
    },

    position: function() {
        var widget_width = this.j_element.width();
        if (this.width) {
            widget_width = this.width;
        }

        this.j_element.css(this.styles(widget_width));

        // Keep boxovers centered when window is resized.
        (function (self) {
            $(window).on('resize', function() {
                self.j_element.css(self.styles(widget_width));
            });
        })(this);

        if (true) {
            this.j_element.find('table').css({
                'width': '' + this.width + 'px',
                'height': '' + this.height + 'px'
            });

            this.j_element.find('iframe').css({
                'width': '' + this.content_width() + 'px',
                'height': '' + this.height + 'px'
            });
        }
    },

    styles: function(widget_width) {
        var window_width = $(window).width();
        var styles = {
            'position': this.positioning,
            'zIndex': 100,
            'left': '' + ((window_width - widget_width) / 2.0) + 'px',
            'top': '' + this.top + 'px',
            'height': '' + this.height + 'px',
            'width': '' + widget_width + 'px'
        };
        return styles;
    },

    show: function() {
        var self = this;
        var background = $('#overlay_background');
        if (true) {
            self.j_element.find('.container_content').html('');
            var el = $(document.createElement('iframe'));
            el.attr('src', self.url);
            self.j_element.find('.container_content').append(el);

            self.j_element.find('.boxover_widget_close').click(function() {
                background.fadeOut("fast");
                self.hide();
                self.onclose();
                return false;
            });

            // @@ make this better - proper inheritance
            self.prepare();
            self.position();
            // This is to force positioning again in Safari, which miscalculates the width initially
            self.j_element.show();
            self.add_to_open_widgets();

            self.show_wait_view();
            el.on("load", function() {
                self.show_content_view();
            });
        }
    },

    show_wait_view: function() {
        var self = this;
        self.j_element.find('.container_content').hide();

        var wait_content = self.j_element.find('.container_wait_content');
        wait_content.css({
            'height': '' + self.height + 'px',
            'background-color': '#ffffff',
            'text-align': 'center',
            'padding-top': '' + self.content_height() / 2.0 + 'px'
        });

        wait_content.show();
    },

    show_content_view: function() {
        var self = this;

        self.j_element.find('.container_wait_content').hide();
        self.j_element.find('.container_content').show();
    },

    definition: function() {
        var self = this;
        var central_element = function() {
            var internal = '';
            if (self.internal_definition) {
                internal = self.internal_definition;
            }
            if (self.title !== null) {
                return ['div.container_center', {
                    valign: 'top'
                },
                ['.container_title_bar', ['.container_close.boxover_widget_close', ['i', {
                    'class': 'fa fa-times icon-dark'
                },
                '']], ['.container_title', self.title]],
                ['.container_content', internal],
                ['.container_wait_content', ['i', {
                    'class': 'fa fa-spinner fa-spin fa-lg'
                }, '']]];
            }
            else {
                return ['div.container_content', {
                    valign: 'top'
                },
                internal];
            }
        };

        return ['#boxover_widget',
        central_element()
        ];
    },

});
